import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { DeliveryDay } from '../../types/delivery-selection.type';

type Props = {
  days: DeliveryDay[];
  selectedDay: DeliveryDay | null;
  onChange: (day: DeliveryDay) => void;
};

export function DeliveryDaySelect({ days, selectedDay, onChange }: Props) {
  const selectedIndex = selectedDay
    ? days.findIndex((day) => day.formattedDate === selectedDay.formattedDate && day.schedule === selectedDay.schedule)
    : -1;

  return (
    <FormControl variant="outlined" size="small">
      <InputLabel>Livraison le</InputLabel>
      <Select
        label="Livraison le"
        value={selectedIndex >= 0 ? selectedIndex : 0}
        onChange={(event) => onChange(days[Number(event.target.value)])}
        style={{ textTransform: 'capitalize' }}
      >
        {days.map((day, index) => (
          <MenuItem key={`${day.formattedDate}-${day.schedule}`} value={index} style={{ textTransform: 'capitalize' }}>
            {day.formattedDate} - {day.schedule}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
